import PropTypes from 'prop-types';
import { augmentClassName } from '../../../../utils/GlobalCssProxy';
import ModalBasic from '../../../atoms/modal-basic';
import styles from './dynamic-greeting.module.scss';

const className = augmentClassName(styles);

const ModalReadMore = ({ onHide, show, modalMessages }) => {
  return (
    <ModalBasic show={show} onHide={onHide} {...className('root')}>
      <ModalBasic.Header>
        <ModalBasic.Title>
          <ModalBasic.Subtitle>{modalMessages[0] && modalMessages[0].title}</ModalBasic.Subtitle>
        </ModalBasic.Title>
        <ModalBasic.CloseButton onClick={onHide} />
      </ModalBasic.Header>
      <ModalBasic.Body {...className('body')}>
        {modalMessages &&
          modalMessages.map((messageData, index) => {
            return (
              <p
                data-key={`${messageData.linkText || ''}-${index}`}
                key={`${messageData.linkText || ''}-${index}`}
                {...className('paragraph-standard')}
              >
                <strong>{messageData.institutionName}: </strong>
                {messageData.message}
              </p>
            );
          })}
      </ModalBasic.Body>
    </ModalBasic>
  );
};

ModalReadMore.propTypes = {
  modalMessages: PropTypes.array,
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool
};

export default ModalReadMore;
